import React from 'react';

import {connect} from 'react-redux';
import cx from 'classnames';
import {fetchTaxonProductsBySlug, fetchTaxonProductsBySlugPosition} from '../../ducks/taxons';

import Products from '../../components/products/Products';
import ProductSkeleton from '../../components/products/ProductSkeleton';

@connect(({taxons}, {taxon, type}) => ({
  products: taxons.products[type][taxon.slug || taxon],
  limited: taxons.products.limited[taxon.slug || taxon]
}))
export default class ProductList extends React.PureComponent {
  static fetchData = ({dispatch, taxon, type, products, limited}) => {
    Promise.all([
    products === undefined && dispatch(fetchTaxonProductsBySlugPosition(type, taxon)),
    limited === undefined && dispatch(fetchTaxonProductsBySlug("limited", taxon))
    ]);
  }
  componentDidMount() {
    ProductList.fetchData(this.props);
  }

  componentDidUpdate(prevProps) {
    ProductList.fetchData(this.props);
  }

  render() {
    const {mainTaxon, products, three, limited} = this.props;

    if (!products || products.isLoading) {
      return (
        <div className={cx('products', three && 'products--three')}>
          {[...Array(12)].map((_, idx) => <ProductSkeleton key={idx} />)}
        </div>
      );
    }

    return (
      <Products
        three={three}
        taxon={mainTaxon}
        limited={limited.items}
        products={products.items.slice(0, 12)}/>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/productList/ProductList.js